const printerCodes = [
    {
        name: "售后1号",
        code: "20210315017134166",
    },
    {
        name: "售后2号",
        code: "20210315017660643",
    },
    {
        name: "售后3号",
        code: "20210315017653988",
    },
    {
        name: "售后4号",
        code: "20210316017640246",
    },
    {
        name: "售后5号",
        code: "20210316018439453",
    },
    {
        name: "售后6号",
        code: "20210316017657878",
    },
    {
        name: "售后7号",
        code: "20210316017892312",
    },
    {
        name: "售后8号",
        code: "20210316017643087",
    }
]

const getPrinterCodes = () => {
    return JSON.parse(JSON.stringify(printerCodes))
}

export default {
    getPrinterCodes
}


// WEBPACK FOOTER //
// ./src/utils/printerCodeUtils.js